import { useMsal } from "@azure/msal-react";
import { useQueryStart, useQueryStatus } from "features/start/data";


export const useStart = () => {
	const query = useQueryStart();
	const msal = useMsal();

	const profile = query.data?.user?.profiles?.[0]; /* temporary while we only support one profile */
	const user = msal.instance?.getActiveAccount();


	return {
		...query.data,
		msalUser: user,
		profile
	};;
};

export const useSettings = () => {
	const query = useQueryStart();

	return { ...query.data.settings };;
};

export const useStatus = useQueryStatus;